import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "sound-select"
};
const _hoisted_2 = {
  class: "buttons-container"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "button-content"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "animation"
}), /*#__PURE__*/_createElementVNode("p", {
  class: "small"
}, "SOUND"), /*#__PURE__*/_createElementVNode("p", {
  class: "big"
}, "ON")], -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "button-content"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "animation"
}), /*#__PURE__*/_createElementVNode("p", {
  class: "small"
}, "SOUND"), /*#__PURE__*/_createElementVNode("p", {
  class: "big"
}, "OFF")], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
    class: "button on",
    text: true,
    onClick: _cache[0] || (_cache[0] = () => _ctx.onSelect(true))
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }), _createVNode(_component_el_button, {
    class: "button off",
    text: true,
    onClick: _cache[1] || (_cache[1] = () => _ctx.onSelect(false))
  }, {
    default: _withCtx(() => [_hoisted_4]),
    _: 1
  })])]);
}